import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=6ecdd268&scoped=true&"
import script from "./SimpleHeader.vue?vue&type=script&lang=ts&"
export * from "./SimpleHeader.vue?vue&type=script&lang=ts&"
import style0 from "./Header.scss?vue&type=style&index=0&id=6ecdd268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecdd268",
  null
  
)

export default component.exports